<template>
  <div class="m-login__signin">
    <div class="m-login__head">
      <h3 class="m-login__title">{{ labels["sign_in_admin"] }}</h3>
    </div>
    <form class="m-login__form m-form" action @input="userInputListener">
      <div
        class="
          m-alert m-alert--outline
          alert alert-danger alert-dismissible
          animated
          fadeIn
        "
        role="alert"
        v-if="errorMessage"
      >
        <span>{{ errorMessage }}</span>
      </div>
      <div class="form-group m-form__group">
        <input
          class="form-control m-input"
          type="text"
          placeholder="Email"
          name="email"
          autocomplete="off"
          v-model="user.email"
        />
      </div>
      <div class="form-group m-form__group">
        <input
          class="form-control m-input m-login__form-input--last"
          type="password"
          placeholder="Mot de passe"
          name="password"
          v-model="user.password"
        />
      </div>
      <div class="row m-login__form-sub">
        <div class="col m--align-right">
          <router-link
            to="/password-reset"
            id="m_login_forget_password"
            class="m-link"
            >{{ labels.forgot_password_prompt }}</router-link
          >
        </div>
      </div>
      <div class="m-login__form-action">
        <button
          id="m_login_signin_submit"
          class="btn btn-focus m-btn m-btn--pill m-btn--custom"
          @click.prevent="startLogin"
        >
          {{ labels["sign_in_action"] }}
          <div class="m-spinner m-spinner--success" v-show="pending"></div>
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { HTTP } from "../../assets/js/axiosConfig";
// Mixins
import TimeoutMsg from "../../assets/js/mixins";
import UserInputListener from "../../assets/js/mixins";
import firebaseMixins from "../../assets/js/firebaseMixins";

export default {
  name: "Login",
  mixins: [TimeoutMsg, UserInputListener, firebaseMixins],
  data() {
    return {
      user: {
        email: "",
        password: "",
      },
      errorMessage: false,
      pending: false,
    };
  },
  computed: {
    ...mapState({
      sessionUser: (store) => store.sessionUser,
      firebaseSignin: (store) => store.firebaseSignin,
      labels: (store) => store.labels,
    }),
    fullyAuthenticated() {
      return this.sessionUser && this.firebaseSignin;
    },
  },
  watch: {
    fullyAuthenticated(value) {
      this.actionAfterFullyAuthenticaded(value);
    },
  },
  methods: {
    ...mapActions(["setUserInfo"]),
    startLogin() {
      this.pending = true;
      if (this.user.email.indexOf("@") !== -1) {
        this.loginAction();
      } else {
        this.pending = false;
        this.errorMessage = this.labels.not_a_valid_email;
        this.timeoutMsg();
      }
    },
    actionAfterFullyAuthenticaded(value) {
      if (value) {
        console.log("hola");
        const previous = localStorage.getItem("redirectUrl");
        console.log(previous);
        localStorage.removeItem("redirectUrl");
        this.$router.push(previous ? previous : { name: "DashboardMain" });
      }
    },
    loginAction() {
      HTTP.post("api/login", this.user)
        .then(() => {
          this.getUserInfo();
        })
        .catch((err) => {
          console.log(err);
          this.errorMessage = this.labels.incorrect_username_or_password;
          this.timeoutMsg();
          this.pending = false;
        });
    },
    getUserInfo() {
      HTTP.get(`api/login/user/email/${this.user.email}`)
        .then((response) => {
          // Call login success: updates localStorage & store values
          this.authenticateUser(response.data.token);
          console.log("before setUserInfo");
          this.setUserInfo(response.data);
          // this.$router.push({ name: 'DashboardMain' });
          this.pending = false;
        })
        .catch((err) => console.log(err));
    },
  },
  mounted() {
    this.actionAfterFullyAuthenticaded(this.fullyAuthenticated);
  },
};
</script>

<style scoped>
.m-login.m-login--1 .m-login__wrapper .m-login__head .m-login__title {
  font-weight: 300;
  font-size: 18px;
  margin-top: 2rem;
}
.m-login.m-login--1 .m-login__wrapper .m-login__form {
  margin-top: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Security/Login.vue